const FilterButtonsOnState = (buttons, state) => {

    if (state !== undefined) {
        buttons = buttons.filter( b => {
            if (b.Workflow) {
                if (b.EntryStates !== undefined) {
                    const stateList = b.EntryStates.split(",").map((item)=>item.trim());
                    return stateList.includes(state.toString());
                } else {
                    return false;
                }
            } else {
                return true;
            }
        });
    }

    return buttons;
}

export default FilterButtonsOnState;